import { httpService } from '~/Services/Service';

// W-0593 — Relatório Centro de Custo (hierárquico, até 4 níveis)
// filtros: { categoria: string|null, status: string|null }

const gerar = (filtros = {}) =>
  httpService.post('/rel-centro-custo/gerar', filtros);

const exportarExcel = (filtros = {}) =>
  httpService.fetch({
    url: '/rel-centro-custo/exportar-excel',
    method: 'post',
    data: filtros,
    responseType: 'blob',
  });

const exportarPdf = (filtros = {}) =>
  httpService.fetch({
    url: '/rel-centro-custo/exportar-pdf',
    method: 'post',
    data: filtros,
    responseType: 'blob',
  });

export default { gerar, exportarExcel, exportarPdf };
